import { ChevronDown, ChevronUp } from 'lucide-react';
import type { SortConfig, SortDirection } from '@/types/list.types';

interface SortableHeaderProps {
  /** Label affiché */
  label: string;
  /** Clé de tri */
  sortKey: string;
  /** Configuration actuelle du tri */
  currentSort?: SortConfig;
  /** Handler de changement de tri */
  onSort: (sortBy: string, sortDirection: SortDirection) => void;
  /** Classes CSS additionnelles */
  className?: string;
  /** Forcer le titre sur une seule ligne */
  nowrap?: boolean;
}

export function SortableHeader({
  label,
  sortKey,
  currentSort,
  onSort,
  className = '',
  nowrap = false,
}: SortableHeaderProps) {
  const isActive = currentSort?.sortBy === sortKey;
  const currentDirection = isActive ? currentSort.sortDirection : null;

  const handleClick = () => {
    if (!isActive) {
      // Premier click : tri DESC
      onSort(sortKey, 'DESC');
    } else if (currentDirection === 'DESC') {
      // Deuxième click : tri ASC
      onSort(sortKey, 'ASC');
    } else {
      // Troisième click : retour au tri par défaut
      onSort(sortKey, 'DESC');
    }
  };

  return (
    <th
      className={`tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-white tw-uppercase tw-tracking-wider ${nowrap ? 'tw-whitespace-nowrap' : ''} tw-cursor-pointer hover:tw-bg-white/10 tw-select-none ${className}`}
      onClick={handleClick}
    >
      <div className="tw-flex tw-items-center tw-gap-1">
        <span>{label}</span>
        <div className="tw-flex tw-flex-col tw-ml-1">
          <ChevronUp
            className={`tw-w-3 tw-h-3 -tw-mb-1 ${
              isActive && currentDirection === 'ASC'
                ? 'tw-text-white tw-opacity-100'
                : 'tw-text-white tw-opacity-50'
            }`}
          />
          <ChevronDown
            className={`tw-w-3 tw-h-3 ${
              isActive && currentDirection === 'DESC'
                ? 'tw-text-white tw-opacity-100'
                : 'tw-text-white tw-opacity-50'
            }`}
          />
        </div>
      </div>
    </th>
  );
}
